/**
 * Created by rxsl-101 on 2018/3/20.
 */
import {MsgBox, Vue} from '../../app.vues';
import {Utils} from '../../app.base';

import SwbRealStaffListForSelect from './RealStaffListForSelect';

Vue.regist(SwbRealStaffListForSelect);

export function openRealStaffListForSelectDlg(params, callback) {
    let title = params['title'] || '集团人员 - 选择';
    let checkBox = params['checkBox'];
    let staffIds = params['staffIds'] || [];
    let disabledRealStaffIds = params['disabledRealStaffIds'] || [];
    let filter = params['filter'] || {};
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 700,
        template: '<swb-real-staff-list-for-select :checkBox="checkBox" :checkedIds="checkedIds" :disabledIds="disabledIds" :filter="filter" ref="swb_real_staff_list_for_select"></swb-real-staff-list-for-select>',
        data: {
            checkBox: checkBox,
            checkedIds: staffIds,
            disabledIds: disabledRealStaffIds,
            filter: filter // 是否包含admin
        },
        okClicked: function () {
            let result = this.$refs.swb_real_staff_list_for_select.getDlgResult() || {};
            if (result.type == 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/realStaff/selectDlg.js
// module id = 2315
// module chunks = 1